var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"enable-background":"new 0 0 100 100","viewBox":"0 0 100 100","xmlns":"http://www.w3.org/2000/svg"}},_vm._l((_vm.icons[_vm.icon]),function(d,index){return _c('path',{key:index,attrs:{"d":d}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }